import React, { PureComponent } from 'react';
import { Field, FieldArray } from 'redux-form';
import { Icon } from 'react-fa';
import { Editor, Image } from '../index';

const renderField = ({ input, label, type, meta: { touched, error } }) => (
  <div className="form-group">
    <label>{label}</label>
    <div>
      <input className="form-control" {...input} type={type} placeholder={label}/>
      {touched && error && <span>{error}</span>}
    </div>
  </div>
);


const renderTeamMembers = ({ fields, meta: { error, submitFailed } }) => (

  <div className="planet-team__persons">
    <div className="planet-team__header">
      <h3>Persons</h3>
      <button className="btn btn-primary" type="button" onClick={() => fields.push({})}>Add new team member</button>
      {submitFailed && error && <span>{error}</span>}
    </div>
    <div className="row">
      {fields.map((member, index) => (
        <div className="col-md-6 col-xs-12" key={index}>
          <div className="planet-team__member" key={index}>

            <button
              type="button"
              className="btn btn-primary btn-circle btn-remove"
              onClick={() => fields.remove(index)}><Icon name="remove"/></button>

            <div className="planet-team__header">
              <h4>Team member #{index + 1}</h4>
            </div>

            <div className="planet-team__member-container-image">
              <div className="planet-team__member-image">
                <Field
                  name={`${member}.imageUrl`}
                  component={Image}/>
              </div>
            </div>

            <Field
              name={`${member}.name`}
              type="text"
              component={renderField}
              label="Name"/>

            <Field
              name={`${member}.job`}
              type="text"
              component={renderField}
              label="Position job"/>

            <div className="planet-team__member--info">
              <label>Info</label>
              <Field
                name={`${member}.info`}
                component={Editor}/>
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
);
const renderGenericsMembers = ({ fields, meta: { error, submitFailed } }) => (

  <div className="planet-team__generics">
    <div className="planet-team__header">
      <h3>Generics</h3>
      <button className="btn btn-primary" type="button" onClick={() => fields.push({})}>Add new generic</button>
      {submitFailed && error && <span>{error}</span>}
    </div>
    <div className="row">
      {fields.map((member, index) => (
        <div className="col-md-6 col-xs-12" key={index}>
          <div className="planet-team__generic-member" key={index}>

            <button
              type="button"
              className="btn btn-primary btn-circle btn-remove"
              onClick={() => fields.remove(index)}><Icon name="remove"/></button>
            <div className="planet-team__header">
              <h4>Generic member #{index + 1}</h4>
            </div>

            <Field
              name={`${member}.name`}
              type="text"
              component={renderField}
              label="Name"/>

          </div>
        </div>
      ))}
    </div>
  </div>
);


class Team extends PureComponent {

  render() {
    return (
      <div className="planet-team">
        <FieldArray name="persons" component={renderTeamMembers}/>
        <hr />
        <FieldArray name="generics" component={renderGenericsMembers}/>
      </div>
    );
  }
}

Team.propTypes = {};
Team.defaultProps = {};

export default Team;



// WEBPACK FOOTER //
// ./src/components/team/Team.js